import { Dispatcher } from '@/APIDispatcher'
import { vm } from '@/main'
import { getUserFilter } from '@/reports/components/ReportUtils'

import Promise from 'bluebird'

Promise.config({
  cancellation: true
})

export const ReportsApi = {
  bqreport (rawQuery, vue) {
    let query = JSON.parse(JSON.stringify(rawQuery))
    //make sure that user is only accessing their own info
    query.filters = ('filters' in query ? query.filters : [])
    return new Promise((resolve, reject, onCancel) => {
      let promise = Dispatcher.post('bqreport', { query: query }).then(s => {
        if (Dispatcher.success(s)) {
          resolve(s)
        } else {
          vm.$notify.error('Report Failed', 'Could not access report: ' + s.errorCode)
          reject(new Error(s.errorCode))
        }
      })
      onCancel(() => {
        promise.cancel()
      })
    })
  },
  fsreport(buyer, seller, start, end) {
    return new Promise((resolve, reject) => {
      Dispatcher.post('reports/firestore/spend', {
        buyer_id: buyer,
        seller_id: seller,
        start_time: start,
        end_time: end
      }).then(s => {
        if (Dispatcher.success(s)) {
          resolve(s.spend)
        } else {
          reject(s.errorCode)
        }
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/reports/api.js